import styled from "styled-components";

const SelectWrapper = styled.div`
  width: 100%;
`;

export default SelectWrapper;
